import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Table, Modal, Icon, Dropdown, Popup } from "semantic-ui-react";

export const CollaboratorEditor = ({
  collaborators,
  onAdd,
  onRemove,
  allUsers,
}) => {
  const [newCollaborators, setNewCollaborators] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [removeModalOpen, setRemoveModalOpen] = useState(false);
  const [collaboratorToRemove, setCollaboratorToRemove] = useState(null);

  const handleAdd = () => {
    onAdd(newCollaborators);
    setNewCollaborators([]);
    setAddModalOpen(false);
  };

  const handleRemove = () => {
    onRemove(collaboratorToRemove);
    setRemoveModalOpen(false);
  };

  return (
    <div>
      <Button secondary onClick={() => setAddModalOpen(true)}>
        Add Collaborator
      </Button>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Collaborator</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body style={{ maxHeight: "200px", overflowY: "auto" }}>
          {collaborators.map((collaborator, index) => (
            <Table.Row key={index}>
              <Table.Cell>{collaborator}</Table.Cell>
              <Table.Cell>
                <Popup
                  content="Remove collaborator"
                  trigger={
                    <Icon
                      name="trash"
                      color="red"
                      onClick={() => {
                        setCollaboratorToRemove(collaborator);
                        setRemoveModalOpen(true);
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  }
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <Modal open={addModalOpen} onClose={() => setAddModalOpen(false)}>
        <Modal.Header>Select Collaborators</Modal.Header>
        <Modal.Content>
          <Dropdown
            placeholder="Select Collaborators"
            fluid
            multiple
            search
            selection
            options={allUsers.map((user) => ({
              key: user,
              text: user,
              value: user,
            }))}
            onChange={(e, { value }) => setNewCollaborators(value)}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setAddModalOpen(false)}>Cancel</Button>
          <Button primary onClick={handleAdd}>
            Add
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal open={removeModalOpen} onClose={() => setRemoveModalOpen(false)}>
        <Modal.Header>Confirm Remove</Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to remove this collaborator?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setRemoveModalOpen(false)}>Cancel</Button>
          <Button negative onClick={handleRemove}>
            Remove
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

CollaboratorEditor.propTypes = {
  collaborators: PropTypes.arrayOf(PropTypes.string).isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  allUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
};
